import type { ReactNode } from 'react';

interface MobileContainerProps {
  children: ReactNode;
  className?: string;
}

export function MobileContainer({ children, className = '' }: MobileContainerProps) {
  return (
    <div className="min-h-screen bg-white flex justify-center">
      <div className={`w-full max-w-[428px] relative ${className}`}>
        {children}
      </div>
    </div>
  );
}
